<template>
  <!-- <v-tooltip bottom>
    <template v-slot:activator="{ on }"> -->
    <TTooltip :value="disabled ? 'Requires TAKT.ing PRO.account' : tooltip">
      <v-btn
        icon
        small
        :disabled="disabled"
        class="ml-4 pa-1 navigation-button"
        :to="{name: route}"
      >
        <TIcon
          v-if="ticon"
          :name="ticon"
          size="24"
        />
        <svg-icon
          class="mr-1 mt-1"
          v-else-if="isSvgIcon(icon)"
          :name="icon"
          :size="25"
        />
        <v-icon v-else>{{icon}}</v-icon>
      </v-btn>
    </TTooltip>
    <!-- </template>
    <span>{{tooltip}}</span>
  </v-tooltip> -->
</template>
<script>
import { mapGetters, } from 'vuex';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    props: [
      'text',
      'ticon',
      'icon',
      'route',
      'disabled',
      'tooltip'
    ],

    components: {
      TIcon,
    },

    computed: {
      ...mapGetters('View', [
        'isSvgIcon'
        ],
      ),
    }
  }
</script>
<style scoped>
.navigation-button:hover,
.v-btn--active {
  background-color: var(--v-color-2-base) !important;
  border-radius: 0px;
  opacity: 1 !important;
  height: 100%;
  width: 28px;
  border-bottom: 1px solid white;
}

.v-btn--active:before {
    opacity: 0 !important;
}
</style>
